(function () {
  if (window.CNTRCardProductSliderLoaded) return;
  window.CNTRCardProductSliderLoaded = true;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function initSlider(slider) {
    if (!slider || slider.dataset.sliderReady === 'true') return;
    slider.dataset.sliderReady = 'true';

    var track = slider.querySelector('[data-slider-track]');
    var progress = slider.querySelector('[data-slider-progress]');
    var link = slider.closest('.cntr-card-slider__link');
    var slides = slider.querySelectorAll('.cntr-card-slider__slide');
    var count = slides.length;

    if (!track || !link || count <= 1) {
      if (count <= 1) {
        slider.style.cursor = 'auto';
      }
      return;
    }

    var index = 0;
    var startX = 0;
    var deltaX = 0;
    var baseX = 0;
    var isPointerDown = false;
    var isDragging = false;
    var suppressClick = false;
    var width = slider.offsetWidth || 1;

function getWidth() {
  return Math.round(slider.getBoundingClientRect().width) || 1;
}

function setTrackPosition(x, animate) {
  var roundedX = Math.round(x);
  track.style.transition = animate ? 'transform 280ms ease' : 'none';
  track.style.transform = 'translate3d(' + roundedX + 'px, 0, 0)';
}

    function setProgress(animate) {
      if (!progress) return;
      progress.style.transition = animate ? 'transform 280ms ease' : 'none';
      progress.style.transform = 'translateX(' + (index * 100) + '%)';
    }

function snapTo(nextIndex, animate) {
  width = Math.round(getWidth());
  index = clamp(nextIndex, 0, count - 1);
  baseX = -(index * width);
  setTrackPosition(baseX, animate);
  setProgress(animate);
}

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      startX = event.clientX;
      deltaX = 0;
      width = getWidth();
      baseX = -(index * width);

      slider.classList.add('is-dragging');

      if (slider.setPointerCapture) {
        try {
          slider.setPointerCapture(event.pointerId);
        } catch (e) {}
      }
    }

function onPointerMove(event) {
  if (!isPointerDown) return;

  deltaX = event.clientX - startX;

  if (Math.abs(deltaX) > 6) {
    isDragging = true;
  }

  if (!isDragging) return;

  var nextX = baseX + deltaX;

  if ((index === 0 && deltaX > 0) || (index === count - 1 && deltaX < 0)) {
    nextX = baseX + deltaX * 0.35;
  }

  setTrackPosition(nextX, false);
}

    function onPointerEnd() {
      if (!isPointerDown) return;

      isPointerDown = false;
      slider.classList.remove('is-dragging');

      var threshold = width * 0.15;

      if (isDragging) {
        if (deltaX <= -threshold) {
          index += 1;
        } else if (deltaX >= threshold) {
          index -= 1;
        }

        index = clamp(index, 0, count - 1);
        snapTo(index, true);

        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 80);
      } else {
        snapTo(index, true);
      }

      deltaX = 0;
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    link.addEventListener(
      'click',
      function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    slider.addEventListener('dragstart', onDragStart);
    slider.addEventListener('pointerdown', onPointerDown);
    slider.addEventListener('pointermove', onPointerMove);
    slider.addEventListener('pointerup', onPointerEnd);
    slider.addEventListener('pointercancel', onPointerEnd);
    slider.addEventListener('lostpointercapture', onPointerEnd);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        snapTo(index, false);
      });
      ro.observe(slider);
    } else {
      window.addEventListener('resize', function () {
        snapTo(index, false);
      });
    }

    snapTo(0, false);
  }

  function initAll() {
    document.querySelectorAll('[data-card-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
})();